export function validateEnumTranslations<T extends Record<string, string>>(
  enumObject: T,
  translation_object: Record<string, Record<string, string>>,
  translate_key = '',
  exit_on_error = false,
): void {
  const enumName = (enumObject as unknown as { constructor?: { name?: string } }).constructor?.name || 'Enum';

  const requiredKeys = Object.values(enumObject).map((value) => `${translate_key}${value}`);
  let hasErrors = false;

  Object.entries(translation_object).forEach(([language, translations]) => {
    const missingKeys = requiredKeys.filter((key) => !(key in translations));

    if (missingKeys.length > 0) {
      hasErrors = true;
      console.error(`❌ Missing ${enumName} translations in '${language}':`, missingKeys);
    }
  });

  if (hasErrors && exit_on_error) {
    const errorMessage = `🛑 Service stopped due to incomplete ${enumName} translations. Please fix the missing translations before restarting.`;
    console.error(errorMessage);
    throw new Error(errorMessage);
  }
}
